import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { ClientFeedback, ClientFeedbackBody } from '../../../types/feedbacks';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useClientFeedbackActions = (whichAction: 'clientFeedbackList' | '') => {
  // query function to fetch client feedback list from database declared here
  const getClientFeedbackListHandler = useQuery({
    queryKey: ['client-feedback-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<ClientFeedback>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        '/client/feedback/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'clientFeedbackList'),
  });

  // mutation function to create new client feedback declared here
  const createClientFeedbackHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: ClientFeedbackBody;
    }): Promise<AcademiaResponse<ClientFeedback>> => {
      const response = await getPrivateAxiosInstance('appointment').post(
        '/client/feedback/create/',
        body
      );

      return response.data;
    },
  });

  return { getClientFeedbackListHandler, createClientFeedbackHandler };
};

export default useClientFeedbackActions;
